import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button, Checkbox, Result, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GetTasksApi from "../../api/tasks/GetTasksApi";
import AddTaskModal from "../modal/add/AddTaskModal";
import moment from "moment";
import ConfirmationModal from "../modal/ConfirmationModal";
import DeleteTaskApi from "../../api/tasks/DeleteTaskApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import EditTaskModal from "../modal/edit/EditTaskModal";
import CompleteTaskApi from "../../api/tasks/CompleteTaskApi";
import PageLoader from "../sub/PageLoader";

function TopPlanTasks(props) {
  const proHeight = document.body.clientHeight;
  const [addModal, setAddModal] = useState(false);
  const [data, setData] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState();
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [loading, setLoading] = useState(false);

  let curLocation = useLocation();

  useEffect(() => {
    getTasks();
  }, [curLocation]);

  async function getTasks() {
    setLoading(true);
    const apiResponse = await GetTasksApi(props.data?.planId);

    if (apiResponse.success) {
      setData(apiResponse.data);
      if (apiResponse.data?.length) {
        setCanShow(true);
      }
    }
    setCanStart(true);
    setLoading(false);
  }

  async function deleteTask() {
    const apiResponse = await DeleteTaskApi(selectedTask?.id);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      getTasks();
    } else {
      openNotificationError("bottomRight", `Couldn't delete. Try again later.`);
    }
    setSelectedTask("");
  }

  async function complete() {
    const apiResponse = await CompleteTaskApi(selectedTask?.id);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      getTasks();
    } else {
      openNotificationError(
        "bottomRight",
        `Couldn't complete. Try again later.`
      );
    }
    setSelectedTask("");
  }

  function renderTasks() {
    let output = [];
    data?.forEach((task) => {
      output.push(
        <div className="flex items-start gap-4 border-b p-4 max-w-4xl">
          <div
            style={{
              border: "1px solid #1da57a",
              backgroundColor: task?.completionStatus && "#1da57a",
            }}
            className={
              "h-4 w-4 border  rounded-sm mt-1 cursor-pointer  " +
              (task?.completionStatus && " cursor-default")
            }
            onClick={() => {
              if (!task?.completionStatus) {
                setCompleteModal(true);
                setSelectedTask(task);
              }
            }}
          ></div>

          <div className="flex items-start  justify-between w-full">
            <div>
              <div className={task?.completionStatus && "line-through"}>
                {task.name}
              </div>
              <div className="flex items-center gap-5 text-xs">
                {task?.taskStartDate && (
                  <div>
                    Start date: {moment(task.taskStartDate).format("DD.MM.YYYY")}
                  </div>
                )}
                <div>
                  Target date: {moment(task.taskEndDate).format("DD.MM.YYYY")}
                </div>
                {task?.completionStatus && (
                  <div>
                    Completion date:
                    {moment(task.completionDate).format("DD.MM.YYYY")}
                  </div>
                )}
                {task?.positions && (
                  <div>
                    Assigned to: {`${task.positions?.users?.firstName || ""} ${task.positions?.users?.lastName || ""}`.trim()} {task.positions?.designations?.name ? `(${task.positions.designations.name})` : ""}
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              {task?.completionStatus ? (
                ""
              ) : (
                <Tooltip title={"Edit"}>
                  <div
                    onClick={(event) => {
                      event.stopPropagation();
                      setEditModal(true);
                      setSelectedTask(task);
                    }}
                    className="text-blue-500 hover:text-blue-600 cursor-pointer"
                  >
                    <EditOutlined />
                  </div>
                </Tooltip>
              )}
              <Tooltip title={"Delete"}>
                <div
                  onClick={(event) => {
                    event.stopPropagation();
                    setDeleteModal(true);
                    setSelectedTask(task);
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      );
    });

    return output;
  }

  function showEmptyTasks() {
    return (
      <div
        style={{ height: proHeight - 188 }}
        className="flex justify-center items-center w-full h-full"
      >
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No Tasks available
          </div>
          <div className="mb-3 text-gray-400">Add tasks to this plan</div>
          <Button onClick={() => setAddModal(true)} type="primary">
            Add a Task
          </Button>
        </div>
      </div>
    );
  }
  return (
    <>
      {canStart && !loading ? (
        canShow ? (
          <div>
            {renderTasks()}
            <div className="py-3 px-4">
              <div
                onClick={() => setAddModal(true)}
                className="cursor-pointer text-blue-500"
              >
                + Add new Task
              </div>
            </div>
          </div>
        ) : (
          showEmptyTasks()
        )
      ) : (
        <div
          style={{ height: proHeight - 188 }}
          className="flex justify-center items-center w-full h-full"
        >
          <PageLoader />
        </div>
      )}
      <AddTaskModal
        visible={addModal}
        planId={props.data?.planId}
        unitId={props.data?.unit?.unitId}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getTasks()}
      />
      <EditTaskModal
        task={selectedTask}
        visible={editModal}
        unitId={props.data?.unit?.unitId}
        handleCancel={() => {
          setSelectedTask();
          setEditModal(false);
        }}
        handleOk={() => getTasks()}
      />
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal(false);
          setSelectedTask("");
        }}
        handleOk={() => deleteTask()}
        text={`Are you sure want to delete this task?`}
        title="Delete"
      />
      <ConfirmationModal
        visible={completeModal}
        handleCancel={() => {
          setCompleteModal(false);
          setSelectedTask("");
        }}
        handleOk={() => complete()}
        text={`Are you sure want to complete this task?`}
        title="Complete"
      />
    </>
  );
}

export default TopPlanTasks;
